/**
 * Stock indicator tiers, sourced from the `stock_indicator` metaobject via GM_STATE.
 *
 * Both PDP consumers — the dot-and-label line under the add-to-cart bar and the underline on a
 * low-stock size pill — resolve a variant's inventory through here, so they can never disagree.
 */

/** The metaobject's sold-out tier. Sold out is handled by the CTA and notify form, not here. */
const OUT_OF_STOCK_TIER = 0

export const getStockIndicators = () => {
  const tiers = window.GM_STATE?.metaobjects?.stock_indicators
  return Array.isArray(tiers) ? tiers : []
}

/**
 * The narrowest tier the quantity falls inside, or null when nothing applies.
 *
 * Untracked variants are emitted as 9999 by product-form.liquid, and an absent or non-numeric
 * value means "unknown depth" — neither can match a tier, so neither is reported as low.
 *
 * @param {number|string} inventory Variant inventory quantity.
 * @param {object[]} tiers Metaobject tiers: { maxQuantity, message, colour }.
 * @returns {{maxQuantity: number, message: string, colour: string}|null}
 */
export const matchStockIndicator = (inventory, tiers = getStockIndicators()) => {
  const quantity = Number(inventory)
  if (!Number.isFinite(quantity) || quantity <= 0) return null

  return (
    tiers
      .map((tier) => ({ ...tier, maxQuantity: Number(tier?.maxQuantity) }))
      .filter((tier) => Number.isFinite(tier.maxQuantity) && tier.maxQuantity > OUT_OF_STOCK_TIER)
      .sort((a, b) => a.maxQuantity - b.maxQuantity)
      .find((tier) => quantity <= tier.maxQuantity) ?? null
  )
}

/** Metaobject messages carry `[quantity]` as the placeholder for the variant's actual depth. */
export const formatStockMessage = (message, quantity) => String(message ?? '').replace('[quantity]', quantity)
